import React, { ReactElement, useRef } from 'react'
import { ApisauceConfig, ApisauceInstance } from 'apisauce'

import create from '../core/APISauceCreateWithAuth/APISauceCreateWithAuth'

const APISauceWithAuthContext = React.createContext<
   null | ((config: ApisauceConfig) => ApisauceInstance)
>(null)

export const APISauceCreateWithAuthProvider = (props: {
   getAccessToken: () => Promise<string | void>
   clearAccessTokenCookie: () => void
   children: ReactElement
}) => {
   const { getAccessToken, children, clearAccessTokenCookie } = props

   const authClientRef = useRef(create(getAccessToken, clearAccessTokenCookie))

   return (
      <APISauceWithAuthContext.Provider value={authClientRef.current}>
         {children}
      </APISauceWithAuthContext.Provider>
   )
}

export const useAPISauceCreateWithAuth = () => {
   const context = React.useContext(APISauceWithAuthContext)

   if (!context) {
      throw new Error('Expected to be wrapped in APISauceWithAuthProvider')
   }

   return context
}
